import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ArrowLeftIcon, DownloadIcon, MailIcon, EditIcon, PrinterIcon, CheckCircleIcon, XCircleIcon, MoreHorizontalIcon, ArchiveIcon, TrashIcon, UserIcon, PhoneIcon, MapPinIcon, CreditCardIcon, TagIcon, FileTextIcon, AlertTriangleIcon, ClockIcon, PackageIcon, TruckIcon, CalendarIcon, CheckIcon } from 'lucide-react';
import { Order, OrderStatus } from './Orders';
export function OrderDetail() {
  const navigate = useNavigate();
  const {
    id
  } = useParams();
  const [showMoreMenu, setShowMoreMenu] = useState(false);
  // Mock data based on the ID or default
  const order: Order = {
    id: id || '220629-1e753',
    status: 'new',
    paymentStatus: 'paid',
    customer: {
      name: 'randy',
      email: 'randy@randy.com',
      address: 'randy',
      mobileNumber: '6596605522',
      additionalPhone: '1234',
      address2: '1234'
    },
    items: [{
      name: 'Kittens',
      quantity: 2,
      price: 111.0
    }],
    total: 222.0,
    date: '29/06/2022',
    time: '14:28',
    transaction: '62bc1b4be3c2250009f1e753',
    transactionStatus: 'confirmed',
    notes: 'Please deliver between 9 AM and 5 PM.'
  };
  const getStatusBadge = (status: OrderStatus) => {
    const styles = {
      new: 'bg-blue-50 text-blue-700 border-blue-200',
      'in-progress': 'bg-amber-50 text-amber-700 border-amber-200',
      open: 'bg-purple-50 text-purple-700 border-purple-200',
      completed: 'bg-green-50 text-green-700 border-green-200',
      cancelled: 'bg-red-50 text-red-700 border-red-200'
    };
    const labels = {
      new: 'New',
      'in-progress': 'In Progress',
      open: 'Open',
      completed: 'Completed',
      cancelled: 'Cancelled'
    };
    return <span className={`inline-flex items-center px-2.5 py-0.5 rounded-md text-xs font-medium border ${styles[status]}`} data-id="element-9398">
        {labels[status]}
      </span>;
  };
  const getPaymentMethod = (transaction?: string) => {
    if (!transaction) return 'Unknown payment method';
    if (transaction.startsWith('62')) return 'Credit Card';
    return 'Bank Transfer';
  };
  const getShippingStatus = (status: OrderStatus) => {
    switch (status) {
      case 'new':
        return 'Awaiting processing';
      case 'in-progress':
        return 'Processing';
      case 'open':
        return 'Ready for pickup';
      case 'completed':
        return 'Delivered';
      case 'cancelled':
        return 'Cancelled';
      default:
        return 'Unknown';
    }
  };
  const formatDate = (dateString: string) => {
    const parts = dateString.split('/');
    if (parts.length !== 3) return dateString;
    const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    const day = parseInt(parts[0]);
    const month = parseInt(parts[1]) - 1;
    const year = parseInt(parts[2]);
    return `${day} ${months[month]} ${year}`;
  };
  return <div className="max-w-[1400px] mx-auto space-y-6" data-id="element-9399">
      {/* Header */}
      <div className="flex items-center justify-between" data-id="element-9400">
        <div className="flex items-center gap-4" data-id="element-9401">
          <button onClick={() => navigate('/orders')} className="p-2 border border-gray-200 rounded-lg text-gray-600 hover:bg-gray-50 transition-colors" data-id="element-9402">
            <ArrowLeftIcon size={18} data-id="element-9403" />
          </button>
          <div data-id="element-9404">
            <div className="flex items-center gap-3" data-id="element-9405">
              <h1 className="text-xl font-semibold text-gray-900" data-id="element-9406">
                Order #{order.id}
              </h1>
              {getStatusBadge(order.status)}
            </div>
            <p className="text-sm text-gray-500 mt-0.5" data-id="element-9407">
              {order.customer.name}
            </p>
          </div>
        </div>

        <div className="flex items-center gap-2" data-id="element-9408">
          <button className="flex items-center gap-2 px-4 py-2 border border-gray-200 rounded-lg text-gray-700 hover:bg-gray-50 text-sm font-medium transition-colors" data-id="element-9409">
            <MailIcon size={16} data-id="element-9410" />
            Send
          </button>
          <button className="flex items-center gap-2 px-4 py-2 border border-gray-200 rounded-lg text-gray-700 hover:bg-gray-50 text-sm font-medium transition-colors" data-id="element-9411">
            <DownloadIcon size={16} data-id="element-9412" />
            Download
          </button>
          <button className="flex items-center gap-2 px-4 py-2 bg-[#F7941D] hover:bg-[#D97B06] text-white text-sm font-medium rounded-lg transition-colors shadow-sm" data-id="element-9413">
            <CheckCircleIcon size={16} data-id="element-9414" />
            Mark Fulfilled
          </button>
          <div className="relative" data-id="element-9415">
            <button onClick={() => setShowMoreMenu(!showMoreMenu)} className="p-2 border border-gray-200 rounded-lg text-gray-600 hover:bg-gray-50 transition-colors" data-id="element-9416">
              <MoreHorizontalIcon size={18} data-id="element-9417" />
            </button>
            {showMoreMenu && <>
                <div className="fixed inset-0 z-10" onClick={() => setShowMoreMenu(false)} data-id="element-9418" />
                <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg border border-gray-200 py-1 z-20" data-id="element-9419">
                  <button onClick={() => setShowMoreMenu(false)} className="w-full flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-50" data-id="element-9420">
                    <PrinterIcon size={16} className="mr-3 text-gray-400" data-id="element-9421" />
                    Print Order
                  </button>
                  <button onClick={() => setShowMoreMenu(false)} className="w-full flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-50" data-id="element-9422">
                    <EditIcon size={16} className="mr-3 text-gray-400" data-id="element-9423" />
                    Edit Order
                  </button>
                  <div className="border-t border-gray-100 my-1" data-id="element-9424" />
                  <button onClick={() => setShowMoreMenu(false)} className="w-full flex items-center px-4 py-2 text-sm text-red-600 hover:bg-red-50" data-id="element-9425">
                    <TrashIcon size={16} className="mr-3" data-id="element-9426" />
                    Cancel Order
                  </button>
                </div>
              </>}
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-9427">
        {/* Main Content */}
        <div className="lg:col-span-2 space-y-6" data-id="element-9428">
          {/* Order Items */}
          <div className="bg-white rounded-xl border border-gray-200 overflow-hidden shadow-sm" data-id="element-9429">
            <div className="px-6 py-4 border-b border-gray-100 flex justify-between items-center" data-id="element-9430">
              <h2 className="text-base font-semibold text-gray-900 flex items-center gap-2" data-id="element-9431">
                <PackageIcon size={18} className="text-gray-500" data-id="element-9432" />
                Order Items
              </h2>
            </div>
            <div className="p-6" data-id="element-9433">
              <div className="space-y-4" data-id="element-9434">
                {order.items.map((item, index) => <div key={index} className="flex justify-between border-b border-gray-100 pb-4 last:border-0 last:pb-0" data-id="element-9435">
                    <div data-id="element-9436">
                      <div className="font-medium text-gray-900" data-id="element-9437">
                        {item.name}
                      </div>
                      <div className="text-sm text-gray-500 mt-1" data-id="element-9438">
                        Quantity: {item.quantity} × ${item.price.toFixed(2)}
                      </div>
                    </div>
                    <div className="font-medium text-gray-900" data-id="element-9439">
                      ${(item.price * item.quantity).toFixed(2)}
                    </div>
                  </div>)}
              </div>

              <div className="mt-6 border-t border-gray-100 pt-4 space-y-3" data-id="element-9440">
                <div className="flex justify-between text-sm" data-id="element-9441">
                  <span className="text-gray-500" data-id="element-9442">Subtotal</span>
                  <span className="text-gray-900 font-medium" data-id="element-9443">
                    ${order.total.toFixed(2)}
                  </span>
                </div>
                <div className="flex justify-between text-sm" data-id="element-9444">
                  <span className="text-gray-500" data-id="element-9445">Shipping</span>
                  <span className="text-gray-900 font-medium" data-id="element-9446">$0.00</span>
                </div>
                <div className="flex justify-between text-sm" data-id="element-9447">
                  <span className="text-gray-500" data-id="element-9448">Tax</span>
                  <span className="text-gray-900 font-medium" data-id="element-9449">$0.00</span>
                </div>
                <div className="flex justify-between text-base font-semibold pt-3 border-t border-gray-100" data-id="element-9450">
                  <span className="text-gray-900" data-id="element-9451">Total</span>
                  <span className="text-[#F7941D]" data-id="element-9452">
                    ${order.total.toFixed(2)}
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* Order Timeline */}
          <div className="bg-white rounded-xl border border-gray-200 overflow-hidden shadow-sm" data-id="element-9453">
            <div className="px-6 py-4 border-b border-gray-100" data-id="element-9454">
              <h2 className="text-base font-semibold text-gray-900 flex items-center gap-2" data-id="element-9455">
                <ClockIcon size={18} className="text-gray-500" data-id="element-9456" />
                Order Timeline
              </h2>
            </div>
            <div className="p-6" data-id="element-9457">
              <div className="space-y-6" data-id="element-9458">
                <div className="flex items-start" data-id="element-9459">
                  <div className="flex-shrink-0 h-6 w-6 rounded-full bg-green-100 flex items-center justify-center mt-0.5" data-id="element-9460">
                    <CheckIcon size={14} className="text-green-600" data-id="element-9461" />
                  </div>
                  <div className="ml-4" data-id="element-9462">
                    <p className="text-sm font-medium text-gray-900" data-id="element-9463">
                      Order placed
                    </p>
                    <p className="text-xs text-gray-500 mt-1" data-id="element-9464">
                      {formatDate(order.date)} at {order.time}
                    </p>
                  </div>
                </div>

                {order.status === 'in-progress' || order.status === 'completed' ? <div className="flex items-start" data-id="element-9465">
                    <div className="flex-shrink-0 h-6 w-6 rounded-full bg-amber-100 flex items-center justify-center mt-0.5" data-id="element-9466">
                      <CheckIcon size={14} className="text-amber-600" data-id="element-9467" />
                    </div>
                    <div className="ml-4" data-id="element-9468">
                      <p className="text-sm font-medium text-gray-900" data-id="element-9469">
                        Processing started
                      </p>
                      <p className="text-xs text-gray-500 mt-1" data-id="element-9470">
                        Order is being processed
                      </p>
                    </div>
                  </div> : <div className="flex items-start" data-id="element-9471">
                    <div className="flex-shrink-0 h-6 w-6 rounded-full bg-gray-100 flex items-center justify-center mt-0.5" data-id="element-9472">
                      <span className="text-xs font-medium text-gray-500" data-id="element-9473">
                        2
                      </span>
                    </div>
                    <div className="ml-4" data-id="element-9474">
                      <p className="text-sm font-medium text-gray-500" data-id="element-9475">
                        Processing
                      </p>
                      <p className="text-xs text-gray-400 mt-1" data-id="element-9476">
                        Waiting to be processed
                      </p>
                    </div>
                  </div>}

                {order.status === 'completed' ? <div className="flex items-start" data-id="element-9477">
                    <div className="flex-shrink-0 h-6 w-6 rounded-full bg-green-100 flex items-center justify-center mt-0.5" data-id="element-9478">
                      <CheckIcon size={14} className="text-green-600" data-id="element-9479" />
                    </div>
                    <div className="ml-4" data-id="element-9480">
                      <p className="text-sm font-medium text-gray-900" data-id="element-9481">
                        Completed
                      </p>
                      <p className="text-xs text-gray-500 mt-1" data-id="element-9482">
                        Order has been fulfilled
                      </p>
                    </div>
                  </div> : <div className="flex items-start" data-id="element-9483">
                    <div className="flex-shrink-0 h-6 w-6 rounded-full bg-gray-100 flex items-center justify-center mt-0.5" data-id="element-9484">
                      <span className="text-xs font-medium text-gray-500" data-id="element-9485">
                        3
                      </span>
                    </div>
                    <div className="ml-4" data-id="element-9486">
                      <p className="text-sm font-medium text-gray-500" data-id="element-9487">
                        Completed
                      </p>
                      <p className="text-xs text-gray-400 mt-1" data-id="element-9488">
                        Waiting to be completed
                      </p>
                    </div>
                  </div>}
              </div>
            </div>
          </div>
        </div>

        {/* Sidebar */}
        <div className="space-y-6" data-id="element-9489">
          {/* Customer Information */}
          <div className="bg-white rounded-xl border border-gray-200 overflow-hidden shadow-sm" data-id="element-9490">
            <div className="px-6 py-4 border-b border-gray-100" data-id="element-9491">
              <h2 className="text-base font-semibold text-gray-900 flex items-center gap-2" data-id="element-9492">
                <UserIcon size={18} className="text-gray-500" data-id="element-9493" />
                Customer Information
              </h2>
            </div>
            <div className="p-6 space-y-4" data-id="element-9494">
              <div className="flex items-center gap-3 mb-2" data-id="element-9495">
                <div className="w-10 h-10 bg-[#F7941D]/10 rounded-full flex items-center justify-center text-[#F7941D] font-semibold" data-id="element-9496">
                  {order.customer.name.charAt(0).toUpperCase()}
                </div>
                <div data-id="element-9497">
                  <div className="font-medium text-gray-900" data-id="element-9498">
                    {order.customer.name}
                  </div>
                  <div className="text-xs text-gray-500" data-id="element-9499">
                    Customer #{order.id.split('-')[0]}
                  </div>
                </div>
              </div>

              <div className="space-y-3 pt-2 border-t border-gray-100" data-id="element-9500">
                <div className="flex items-start gap-3" data-id="element-9501">
                  <MailIcon size={16} className="text-gray-400 mt-0.5" data-id="element-9502" />
                  <div data-id="element-9503">
                    <div className="text-sm text-gray-900" data-id="element-9504">
                      {order.customer.email}
                    </div>
                    <div className="text-xs text-gray-500" data-id="element-9505">Email</div>
                  </div>
                </div>
                <div className="flex items-start gap-3" data-id="element-9506">
                  <PhoneIcon size={16} className="text-gray-400 mt-0.5" data-id="element-9507" />
                  <div data-id="element-9508">
                    <div className="text-sm text-gray-900" data-id="element-9509">
                      {order.customer.mobileNumber}
                    </div>
                    <div className="text-xs text-gray-500" data-id="element-9510">Mobile</div>
                  </div>
                </div>
                {order.customer.additionalPhone && <div className="flex items-start gap-3" data-id="element-9511">
                    <PhoneIcon size={16} className="text-gray-400 mt-0.5" data-id="element-9512" />
                    <div data-id="element-9513">
                      <div className="text-sm text-gray-900" data-id="element-9514">
                        {order.customer.additionalPhone}
                      </div>
                      <div className="text-xs text-gray-500" data-id="element-9515">
                        Additional Phone
                      </div>
                    </div>
                  </div>}
                <div className="flex items-start gap-3" data-id="element-9516">
                  <MapPinIcon size={16} className="text-gray-400 mt-0.5" data-id="element-9517" />
                  <div data-id="element-9518">
                    <div className="text-sm text-gray-900" data-id="element-9519">
                      {order.customer.address}
                    </div>
                    {order.customer.address2 && <div className="text-sm text-gray-900 mt-0.5" data-id="element-9520">
                        {order.customer.address2}
                      </div>}
                    <div className="text-xs text-gray-500 mt-0.5" data-id="element-9521">
                      Shipping Address
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Payment Information */}
          <div className="bg-white rounded-xl border border-gray-200 overflow-hidden shadow-sm" data-id="element-9522">
            <div className="px-6 py-4 border-b border-gray-100" data-id="element-9523">
              <h2 className="text-base font-semibold text-gray-900 flex items-center gap-2" data-id="element-9524">
                <CreditCardIcon size={18} className="text-gray-500" data-id="element-9525" />
                Payment Information
              </h2>
            </div>
            <div className="p-6 space-y-4" data-id="element-9526">
              <div className="flex items-start gap-3" data-id="element-9527">
                <CreditCardIcon size={16} className="text-gray-400 mt-0.5" data-id="element-9528" />
                <div data-id="element-9529">
                  <div className="text-sm text-gray-900" data-id="element-9530">
                    {getPaymentMethod(order.transaction)}
                  </div>
                  <div className="text-xs text-gray-500" data-id="element-9531">Payment Method</div>
                </div>
              </div>
              <div className="flex items-start gap-3" data-id="element-9532">
                <TagIcon size={16} className="text-gray-400 mt-0.5" data-id="element-9533" />
                <div data-id="element-9534">
                  <div className="text-sm text-gray-900 capitalize" data-id="element-9535">
                    {order.paymentStatus}
                  </div>
                  <div className="text-xs text-gray-500" data-id="element-9536">Payment Status</div>
                </div>
              </div>
              {order.transaction && <div className="flex items-start gap-3" data-id="element-9537">
                  <FileTextIcon size={16} className="text-gray-400 mt-0.5" data-id="element-9538" />
                  <div data-id="element-9539">
                    <div className="text-sm text-gray-900 break-all" data-id="element-9540">
                      {order.transaction}
                    </div>
                    <div className="text-xs text-gray-500" data-id="element-9541">Transaction ID</div>
                  </div>
                </div>}
              {order.transactionStatus && <div className="flex items-start gap-3" data-id="element-9542">
                  {order.transactionStatus === 'confirmed' ? <CheckCircleIcon size={16} className="text-green-500 mt-0.5" data-id="element-9543" /> : order.transactionStatus === 'failed' ? <AlertTriangleIcon size={16} className="text-red-500 mt-0.5" data-id="element-9544" /> : <ClockIcon size={16} className="text-amber-500 mt-0.5" data-id="element-9545" />}
                  <div data-id="element-9546">
                    <div className="text-sm text-gray-900 capitalize" data-id="element-9547">
                      {order.transactionStatus}
                    </div>
                    <div className="text-xs text-gray-500" data-id="element-9548">
                      Transaction Status
                    </div>
                  </div>
                </div>}
            </div>
          </div>

          {/* Shipping Status */}
          <div className="bg-white rounded-xl border border-gray-200 overflow-hidden shadow-sm" data-id="element-9549">
            <div className="px-6 py-4 border-b border-gray-100" data-id="element-9550">
              <h2 className="text-base font-semibold text-gray-900 flex items-center gap-2" data-id="element-9551">
                <TruckIcon size={18} className="text-gray-500" data-id="element-9552" />
                Shipping Status
              </h2>
            </div>
            <div className="p-6" data-id="element-9553">
              <div className="text-sm font-medium text-gray-900 mb-4" data-id="element-9554">
                {getShippingStatus(order.status)}
              </div>
              {order.notes && <div className="bg-gray-50 rounded-lg p-3 border border-gray-100" data-id="element-9555">
                  <div className="text-xs font-medium text-gray-700 mb-1" data-id="element-9556">
                    Customer Notes:
                  </div>
                  <p className="text-sm text-gray-600" data-id="element-9557">{order.notes}</p>
                </div>}
            </div>
          </div>
        </div>
      </div>
    </div>;
}